
namespace TabAurous.HR {

    @Serenity.Decorators.registerClass()
    export class EmploymentTypeGrid extends _Ext.GridBase<EmploymentTypeRow, any> {
        protected getColumnsKey() { return 'HR.EmploymentType'; }
        protected getDialogType() { return EmploymentTypeDialog; }
        protected getIdProperty() { return EmploymentTypeRow.idProperty; }
        protected getInsertPermission() { return EmploymentTypeRow.insertPermission; }
        protected getLocalTextPrefix() { return EmploymentTypeRow.localTextPrefix; }
        protected getService() { return EmploymentTypeService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}